var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tag',{attrs:{"size":"mini","type":_vm.status.tagType}},[_vm._v(_vm._s(_vm.status.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }